import React from "react";
import {List} from "../modules/Tests";

export function TestsListPage(props) {
  return (
    <List {...props} />
  );
}
